import { createAction, props } from '@ngrx/store';
import { NavigationExtras } from '@angular/router';

/**
 * Does a relative route to /{tenant}/{merchantId}/{language}/.
 * @param * string or numberd params.
 * @returns RouteTo
 */
export const routeTo = createAction('[Routing] Route To', props<{ payload: (string | number)[] }>());

/**
 * Does a relative route to /{tenant}/{merchantId}/{language}/.
 * @param * string or numberd params.
 * @returns RouteTo
 */
export const routeToWithOptions = createAction(
	'[Routing] Route To With Options',
	props<{ options: NavigationExtras; routeParams: (string | number)[] }>()
);

/**
 * Does a full route to. You must provide all arguments.
 * @param * string or numberd params.
 * @returns FullRouteTo
 */
export const fullRouteTo = createAction('[Routing] Full Route To', props<{ payload: (string | number)[] }>());

/**
 * Goes back to previous page
 */
export const goBack = createAction('[Routing] Go Back');
